(function () {
  'use strict';

  /* @ngdoc object
   * @name mlpMarketplace
   * @description
   *
   */
  angular
    .module('mlpMarketplace', [
      'ui.router'
    ]);
}());
